import React from 'react';

import { Alert, Button, Typography } from 'antd';

import { useGetBlacklistEntries } from 'v2/hooks/useGetBlacklistEntries';
import { useGetFeatureAccess } from 'v2/hooks/useGetFeatureAccess';
import { BlacklistReasonIds } from 'v2/interfaces/blacklist';
import { USER_IN_BLACKLIST_ERROR_STATUS } from 'v2/interfaces/featureAccess';

const messages = {
  standard: {
    textContent:
      'Nossos meios de pagamento detectaram transações que podem trazer prejuízos financeiros à sua conta. Responda o Formulário o quanto antes para que possamos te auxiliar da melhor forma. Enquanto analisamos, as funções "Transferir" e "Antecipar" ficarão bloqueadas.',
    formLink: 'https://sbchz.share.hsforms.com/21lCpCDNpTzaATSgXGLB8-Q'
  },
  irregularDocument: {
    textContent:
      'Encontramos uma inconsistência no seu cadastro (CNPJ/CPF). Para garantir a segurança da plataforma e das suas vendas, é necessário regularizar seu documento. Preencha o formulário o quanto antes para receber nosso suporte.Durante a análise, as funções "Transferir" e "Antecipar" ficarão temporariamente bloqueadas.',
    formLink: 'http://suporte.eduzz.com/regularizar-cadastro'
  }
};

function BlacklistMessage() {
  const { data: featureAccessData } = useGetFeatureAccess();
  const { data: blacklistEntries } = useGetBlacklistEntries();

  const transferAccessData = featureAccessData?.transfer;

  if (transferAccessData?.code !== USER_IN_BLACKLIST_ERROR_STATUS) {
    return null;
  }

  const messageData = blacklistEntries?.some(entry => entry?.reason?.id === BlacklistReasonIds.IRREGULAR_DOCUMENT)
    ? messages.irregularDocument
    : messages.standard;

  return (
    <Alert
      showIcon={false}
      className='mb-4'
      type='error'
      action={
        <Button danger type='primary' target='_blank' href={messageData.formLink} rel='noreferrer'>
          Responder Formulário
        </Button>
      }
      message={
        <Typography.Text>
          {messageData.textContent}{' '}
          <Typography.Link
            target='_blank'
            href='https://ajuda.eduzz.com/hc/pt-br/articles/6734291431067-Estou-com-problemas-nas-minhas-transfer%C3%AAncias-e-agora'
            rel='noreferrer'
          >
            Saiba mais
          </Typography.Link>
        </Typography.Text>
      }
    />
  );
}

export default BlacklistMessage;
